import React, { useEffect } from 'react'
import "./about.css";
import Aos from "aos";
import "aos/dist/aos.css";

import king from "../imgz/lastGIF.gif";
import Text from './Text';

function About() {

    useEffect(() => {
        Aos.init({duration: 2000});
    }, [])


    return (
        <div  className="about" id="about">
            <div className="words" >
                <h2>ABOUT US</h2>
                <p data-aos="fade-down">Hello, karibu katika Mindz Websites, tunatengeneza websites nzuri na za kuvutia
                    tunatengeneza websites aina zote kuanzia websites za kibiashara hadi websites binafsi,
                    blogs, mapishi, michezo, sanaa, dini, shule, kila eneo tupo, tuna uzoefu wa zaid ya miaka 5 
                    kwenye website development na tunatumia teknolojia ya kisasa na ya hali ya juu.
                </p>
                <div data-aos="flip-left" className="dom"><Text/></div>
            </div>
            <div className="logo">
            <img data-aos="fade-down" src={king} alt="" />
            </div>
            
        </div>
    )
}

export default About
